import { trackEvent } from '@jotta/grpc-connect-client/clientEvent'

import type { PhotoActionType } from './PhotoActions.types'

export function trackPersonPhotosAction(actionType: PhotoActionType) {
  switch (actionType) {
    case 'SHARE_PHOTO':
      trackEvent('PEOPLE_ALBUM_PHOTOS_SHARED')
      break
    case 'ADD_PHOTOS_TO_ALBUM':
      trackEvent('PEOPLE_ALBUM_PHOTOS_ADDED_TO_ALBUM')
      break
    case 'DOWNLOAD_PHOTOS':
      trackEvent('PEOPLE_ALBUM_PHOTOS_DOWNLOADED')
      break
  }
}
